<template>
  <div class="sync">
    <el-dialog
      :close-on-click-modal="false"
      title="地址智能识别"
      width="600px"
      :visible.sync="visible"
      :before-close="handleClose"
    >
      <div>
        <el-input
          type="textarea"
          :rows="8"
          :placeholder="
            `1、国外地址格式：
Sally Deming
33 SMOKE RIDGE RD
QUEENSBURY, NY 12804-7943
美国 
2、国内地址格式：
清远市清城区石角镇美林湖大东路口佰仹公司 郑万顺 15345785872`
          "
          v-model="textarea"
        >
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="text"
          style="float:left;"
          @click="
            handleCopy(`1、国外地址格式：
Sally Deming
33 SMOKE RIDGE RD
QUEENSBURY, NY 12804-7943
美国 
2、国内地址格式：
清远市清城区石角镇美林湖大东路口佰仹公司 郑万顺 15345785872`)
          "
          size="small"
          >复制样例</el-button
        >
        <el-button @click="handleClose" size="small">返回</el-button>
        <el-button type="primary" @click="sureImport" size="small">
          确定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getBDToken, getBDAddress } from "@/api/system/config"
import axios from "axios"
export default {
  name: "SyncOrder",
  data() {
    return {
      shopList: [],
      multipleSelection: [],
      percent: 0,
      loadingVisible: false,
      resultList: [],
      timer: null,
      successFlag: false,
      message: "数据可能延迟，请稍后刷新",
      showMessage: false,
      textarea: ``,
    }
  },
  props: {
    visible: {
      type: Boolean,
      default() {
        return false
      },
    },
  },
  watch: {
    visible() {
      if (this.visible) {
        this.textarea = ""
      }
    },
  },
  mounted() {},
  destroyed() {},
  methods: {
    getData() {},
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    handleClose() {
      this.$emit("onClose")
      this.loadingVisible = false
    },
    completeDate(value) {
      return value < 10 ? "0" + value : value
    },
    async sureImport() {
      if (this.textarea.trim() == "") {
        this.msgError("请输入内容")
        return
      }

      let us = true
      if (/.*[\u4e00-\u9fa5]+.*$/.test(this.textarea.replace("美国", ""))) {
        us = false
      }

      if (!us) {
        let text = this.textarea
        let provinces = [
          "北京市",
          "广东省",
          "山东省",
          "江苏省",
          "河南省",
          "上海市",
          "河北省",
          "浙江省",
          "香港特别行政区",
          "陕西省",
          "湖南省",
          "重庆市",
          "福建省",
          "天津市 ",
          "云南省",
          "四川省",
          "广西壮族自治区",
          "安徽省",
          "海南省 ",
          "江西省 ",
          "湖北省",
          "山西省",
          "辽宁省",
          "台湾省 ",
          "黑龙江",
          "内蒙古自治区 ",
          "澳门特别行政区",
          "贵州省 ",
          "　甘肃省",
          "　青海省 ",
          "新疆维吾尔自治区",
          "　西藏区",
          "吉林省",
          "宁夏回族自治区",
        ]
        for (let record of provinces) {
          text = text.replace(record, "")
        }
        let result = await getBDToken()
        let address = await axios({
          method: "post",
          url:
            "https://aip.baidubce.com/rpc/2.0/nlp/v1/address?access_token=" +
            result.msg,
          data: { text: text },
          headers: {},
        })
        address.data.state = "CN"
        this.$emit("update", address.data)
      } else {
        let data = {
          detail: "",
          town: "",
          phonenum: "",
          province: "",
          person: "",
          county: "",
          city: "",
          county_code: "",
        }
        try {
          let addrArray = this.textarea.split("\n")
          data.person = addrArray[0]
          data.detail = addrArray[1]
          let array = addrArray[2].split(",")
          data.city = array[0]
          array = array[1].trim().split(" ")
          data.province = array[0]
          data.county_code = array[1]
          data.state = "US"
        } catch (error) {}
        this.$emit("update", data)
      }
    },
    handleCopy(text) {
      let target = document.createElement("textarea") //创建input节点
      target.value = text // 给input的value赋值
      document.body.appendChild(target)
      target.value = text // 修改文本框的内容
      target.select() // 选中文本
      document.execCommand("copy") // 执行浏览器复制命令
      this.msgSuccess("复制成功")
    },
  },
}
</script>

<style scoped>
.sync /deep/.el-table::before {
  display: none;
}
.sync-table {
  overflow-y: auto;
  max-height: 260px;
}
.status {
  margin: 10px 0;
}
.red {
  color: red;
}
.detail-wrap {
  max-height: 180px;
  overflow-y: auto;
}
.detail .list {
  padding: 5px 20px;
  box-sizing: border-box;
  width: 100%;
}
</style>
